import { Dropdown } from 'primereact/dropdown';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcherComponent = () => {
    const { i18n, t } = useTranslation('commom');
    const [flag, setFlag] = useState(()=>{
        const userLanguage = localStorage.getItem("freeliefs_user_language");
        try{
            if (userLanguage) 
                return userLanguage 
            else {
                const language = navigator?.language?.split('-')[1] ? navigator?.language?.split('-')[1] : 'US'
                localStorage.setItem("freeliefs_user_language", language)
                return language
            }
        } catch {
            return navigator?.language?.split('-')[1] ? navigator?.language?.split('-')[1] : 'US'
        }
    })
    const languages = [
        {value: 'US', label: 'English'},
        {value: 'ES', label: 'Español'},
        {value: 'BR', label: 'Português'},
    ]

    useEffect(()=>{
        if (flag) {
            i18n.changeLanguage(flag === 'BR' ? 'pt' : flag === 'US' ? 'en' : flag.toLowerCase());
            localStorage.setItem("freeliefs_user_language", flag)
        }
    },[flag])

    const changeLanguage = (e) => {
        setFlag(e.target.value)
    };
  
    return (
        <div className='flex flex-column'>
            <span className='text-xs md:text-sm'>{t('language')}</span>
            <Dropdown  panelClassName='text-sm m-0 p-0' className='text-sm w-4rem'
            value={flag} onChange={changeLanguage} options={languages} itemTemplate={e=><div><img alt="flag country" className='w-1rem' src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${e.value}.svg`}/> <span>{e.label}</span></div>}
            valueTemplate={<img alt="flag country" className='w-1rem' src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${flag}.svg`}/>}/>
        </div>
    );
};

export default LanguageSwitcherComponent;